import { Observable, from } from 'rxjs';
import { IdNomeDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { ENDPOINTS } from '@/settings/api-settings';
import { apiClient } from './api';
import { map } from 'rxjs/operators';
import { ModeloParmDTO, FiltroModeloParmDTO, ModeloListItemDTO, ModeloDTO } from '@/interfaces/bag-models';

export function getBagModelsProducts(): Observable<IdNomeDTO[]> {
  return from(apiClient.get(ENDPOINTS.BAG_MODELS_PRODUCTS)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function findBagModels(filtro: FiltroModeloParmDTO): Observable<ResultPagDTO<ModeloListItemDTO>> {
  return from(apiClient.get(ENDPOINTS.BAG_MODELS, filtro)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function getBagModelsById(id: Number): Observable<ModeloDTO> {
  return from(apiClient.get(`${ENDPOINTS.BAG_MODELS}/${id}`)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function saveBagModel(modelo: ModeloParmDTO): Observable<Number> {
  if (modelo.id) {
    return from(apiClient.put(ENDPOINTS.BAG_MODELS, modelo)).pipe(map((r: any) => (!!r.data ? r.data : [])));
  }
  return from(apiClient.post(ENDPOINTS.BAG_MODELS, modelo)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}
